import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=91d58cae"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=91d58cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports